import React from "react";

function TimelineSubmitForm({ smallScreen, formSection }) {
  if (smallScreen) {
    return (
      <ol class="mx-4 relative border-s-2 border-gray-200 ">
        <li class="mb-6 ms-6">
          <span
            class={`absolute flex items-center justify-center w-5 h-5 ${
              formSection === "basic-info" ||
              formSection === "assessment-form" ||
              formSection === "submitted-form"
                ? "bg-black"
                : "bg-gray-400"
            } rounded-full -start-[11px] top-[0px]`}
          />
          <p class="text-xs sm:text-sm font-medium">
            Fill in the basic information and choose program
          </p>
        </li>
        <li class="mb-6 ms-6">
          <span
            class={`absolute flex items-center justify-center w-5 h-5 ${
              formSection === "assessment-form" ||
              formSection === "submitted-form"
                ? "bg-black"
                : "bg-gray-400"
            } rounded-full -start-[11px]`}
          />
          <p class="text-xs sm:text-sm font-medium">
            Start to fill in Self Assessment Guide
          </p>
        </li>
        <li class="ms-6">
          <span
            class={`absolute flex items-center justify-center w-5 h-5 ${
              formSection === "submitted-form" ? "bg-black" : "bg-gray-400"
            } rounded-full -start-[11px] bottom-[0px]`}
          />
          <p class="text-xs sm:text-sm font-medium">Confirm and submit.</p>
        </li>
      </ol>
    );
  } else {
    return (
      <ol className="mx-4 items-center sm:flex">
        <li className="relative mb-6 sm:mb-0">
          <div className="flex items-center">
            <div
              className={`z-10 flex items-center justify-center w-5 h-5 ${
                formSection === "basic-info" ||
                formSection === "assessment-form" ||
                formSection === "submitted-form"
                  ? "bg-black"
                  : "bg-gray-400"
              } rounded-full shrink-0`}
            ></div>
            <div className="flex w-full bg-gray-200 h-0.5"></div>
          </div>
          <div className="mt-3 sm:pe-8">
            <p className="text-xs sm:text-base xl:text-lg font-medium">
              Fill in the basic information and choose program
            </p>
          </div>
        </li>
        <li className="relative mb-6 sm:mb-0">
          <div className="flex items-center">
            <div
              className={`z-10 flex items-center justify-center w-5 h-5 ${
                formSection === "assessment-form" ||
                formSection === "submitted-form"
                  ? "bg-black"
                  : "bg-gray-400"
              } rounded-full shrink-0`}
            ></div>
            <div className="flex w-full bg-gray-200 h-0.5"></div>
          </div>
          <div className="mt-3 sm:pe-8">
            <p className="text-xs sm:text-base xl:text-lg font-medium">
              Start to fill in Self Assessment Guide
            </p>
          </div>
        </li>
        <li className="relative mb-6 sm:mb-0">
          <div className="flex items-center">
            <div
              className={`z-10 flex items-center justify-center w-5 h-5 ${
                formSection === "submitted-form" ? "bg-black" : "bg-gray-400"
              } rounded-full shrink-0`}
            ></div>
            <div className="flex w-full bg-white h-0.5"></div>
          </div>
          <div className="mt-3 sm:pe-8">
            <p className="text-xs sm:text-base xl:text-lg font-medium">
              Confirm and submit
            </p>
          </div>
        </li>
      </ol>
    );
  }
}

export default TimelineSubmitForm;
